import { render, staticRenderFns } from "./CoozzyExternalLinkIcon.vue?vue&type=template&id=6bcd4273&scoped=true"
import script from "./CoozzyExternalLinkIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyExternalLinkIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyExternalLinkIcon.vue?vue&type=style&index=0&id=6bcd4273&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcd4273",
  null
  
)

export default component.exports